<template>
  <div class="manager_pathway" v-if="isModalVisible">

    <PathwayBuilderCatalogLists
      :isModalVisible="isPathwayBuilderCatalogListsModalVisible"
      ref="PathwayBuilderCatalogLists"
      @close="closeCatalogLists()">
    </PathwayBuilderCatalogLists>

    <PathwayBuilderAddCatalog
      :isModalVisible="isPathwayBuilderAddCatalogModalVisible"
      ref="PathwayBuilderAddCatalog"
      @close="isPathwayBuilderAddCatalogModalVisible = false">
    </PathwayBuilderAddCatalog>

  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import PathwayBuilderCatalogLists from '@/components/manager/pathway_builder_cataloglists.vue';
import PathwayBuilderAddCatalog from '@/components/manager/pathway_builder_add_catalog_modal.vue';
import CreatePathwayStepModal from '../manager/create-pathway-modal.vue';
import EditPathwayStepModal from '../manager/create-pathway-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import router from '../../router/index.js';
import { store } from '../../store/store';

const stepTitleValue = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"];

export default {
  props: ['isModalVisible', 'pathwayId'],
  components: {
    PathwayBuilderCatalogLists,
    PathwayBuilderAddCatalog,
    CreatePathwayStepModal,
    EditPathwayStepModal,
    DeleteModal,
  },
  data() {
    return {
      isPathwayBuilderCatalogListsModalVisible: false,
      isPathwayBuilderAddCatalogModalVisible: false,
      pathway_step_obj: {
        pathway: [],
        steps: [],
        removed_objective: [],
        removed_step: [],
        flag: 'Insert',
      },
      addStepModalVisible: false,
      addObjectiveModalVisible: false,
      stepTitle: '',
      stepDescription: '',
      stepIndex: '',
      objectiveIndex: '',
      objectiveType: '',
      objectiveId: '',
      objectiveLoading: false,
      objectiveOptions: [],
      assessmentOptions: [],
      courseOptions: [],
      tasklistOptions: [],
      certificateOptions: [],
      isDeleteModalVisible: false,
      deleteList: '',
      deleteMessage: '',
      loading: false,
    }
  },
  methods: {
    closeCatalogListsOpenBuildown() {
      this.isPathwayBuilderCatalogListsModalVisible = false;
      this.isPathwayBuilderAddCatalogModalVisible = false;
      this.$parent.isopenPathwayCatalogBuilderVisible = false;
      this.$parent.PathwayCatalogFlag(0);
      this.$parent.createStepDetails();
    },
    backToPathwayListsPage() {
      router.push("/manager-pathway");
    },
    checkIsManager() {
      return checkIsManager();
    },
    backToPathwayDetailPage() {
      router.push('/manager-pathway-step-builder/' + this.pathwayId);
      window.location.reload();
    },
    onSubmit() {
      var flag = 0;
      if(flag == 0) {
        axios('/post-pathway-step-details',
          {
            method: 'POST',
            data:
              {
                pathway_step_obj: this.pathway_step_obj,
                accountId: this.$store.state.user_accountid,
              },
          }
        )
        .then((resp) => {
            this.backToPathwayDetailPage();
            
        })
        .catch(error => {
          if(error.response.data.message == 'Access denied.') {
            router.push("/forbidden");
          }
        });
      }

    },


    callButtonCatalogClose() {
      this.$parent.PathwayCatalogFlag(1);
    },
    closeCatalogLists() {
      this.isPathwayBuilderCatalogListsModalVisible = false;
      this.isPathwayBuilderAddCatalogModalVisible = false;
      this.$parent.isopenPathwayCatalogBuilderVisible = false;
      this.$parent.PathwayCatalogFlag(0);
    },
    closeCatalogListsAfterDragDrop() {
      this.pathway_step_obj.steps = [];
      var stepObj = this.$store.state.catalog_pathway_steps;
      this.pathway_step_obj.removed_step = this.$store.state.pathway_steps.removed_step;
      this.pathway_step_obj.removed_objective = this.$store.state.pathway_steps.removed_objective;
      for(var i=0; i<stepObj.length; i++) {
        if(stepObj[i].stepTitle) {
          this.pathway_step_obj.steps.push({
            id: '',
            stepTitle: stepObj[i].stepTitle,
            stepDescription: stepObj[i].stepDescription,
            objective: stepObj[i].objective,
            edit: false,
            update: false,
            modified: false,
          });
        }
      }
      this.pathway_step_obj.pathway = {
        id: this.pathwayId,
      }
      this.$store.dispatch('pathway_steps', this.pathway_step_obj);
      this.isPathwayBuilderCatalogListsModalVisible = false;
      this.isPathwayBuilderAddCatalogModalVisible = false;
      this.onSubmit();
    },
    openPathwayBuilderCatalogModal() {
      this.isPathwayBuilderCatalogListsModalVisible = true;
      this.isPathwayBuilderAddCatalogModalVisible = true;
    },
  },
  created() {

  },
}
</script>

<style scoped>
.rounded {
  border-radius: 10px !important;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
	.pathwayBtn, .pathwayBtn:hover, .pathwayBtn:focus {
		padding: 7px 7px; border-radius: 15px !important;
		width: 130px;
	}
	.manager_pathway .pathways_step {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top-left-radius: 15px !important;
		border-top-right-radius: 15px !important;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
	}
	.manager_pathway .pathways_ojective_step {
		min-height: 80px;
		width: 79.77%;
		margin-left: 41px;
		margin-right: 82px;
		border: 0;
		background-color: #E2F3F9;
		padding-top: 10px;
		color: #778182;
		font-size: 13px;
		padding-left: 8px;
		border-top: 0px solid #B2B2B2;
		box-shadow: 0 0px 1px rgba(0,0,0,.15) !important;
		border-radius: 0;
		font-weight: 600;

	}
	.manager_pathway .add_objective {
		height: 80px;
		width: 80%;
		margin-left: 40px;
		border-top: 0;
		box-shadow: 0px 0px 5px rgba(0,0,0,.15) !important;
	}
	.step-index {
		color: #778182;
		font-size: 12px;
	}
	.manager_pathway .subtask-wrapper {
		margin-top: 15px;
		margin-left: 40px;
		margin-right: 30px;
	}
	.manager_pathway .subtask-wrapper .panel-title {
		border: 1px solid #B2B2B2;
		background-color: #FFF;
		float: left;
		width: 100%;
		margin-bottom: 10px;
		border-radius: 10px;
		height: 40px;
		color: #646F71 !important;
	}
	.manager_pathway .subtask-wrapper .panel-title a, .manager_pathway .subtask-wrapper .panel-title a:hover{
		color: #646F71 !important;
	}
	.angle_class_font {
		font-size: 25px !important;
		margin-top: 0px !important;
		color: #646F71 !important;
	}
	.objective-panel {
		border: 1px solid #B2B2B2;
		background-color: #FFF;
		float: left;
		padding-left: 12px;
		padding-right: 12px;
		color: #646F71 !important;
		width: 90%;
		min-height: 85px;
		margin-bottom: 12px;
		border-radius: 8px;
	}
	.objective-panel p {
		font-size: 13px;
	}
  .report-panel-container {
    justify-content: left;
  }
	.line-height-15 {
		line-height: 15px;
	}

</style>



// WEBPACK FOOTER //
// src/components/manager/pathway_builder.vue